"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeConversionController = /** @class */ (function () {
    function TimeConversionController(service) {
        this.service = service;
    }
    TimeConversionController.prototype.unixToArdor = function (timestampInMsec, isTestnetTimestamp) {
        return isTestnetTimestamp ? this.service.unixToArdorTestnet(timestampInMsec)
            : this.service.unixToArdorMainnet(timestampInMsec);
    };
    TimeConversionController.prototype.ardorToUnix = function (timestamp, isTestnetTimestamp) {
        return isTestnetTimestamp ? this.service.ardorToUnixTestnet(timestamp)
            : this.service.ardorToUnixMainnet(timestamp);
    };
    return TimeConversionController;
}());
exports.default = TimeConversionController;
